import { render, staticRenderFns } from "./SpecialistForm.vue?vue&type=template&id=0ac74bac&scoped=true"
import script from "./SpecialistForm.vue?vue&type=script&lang=js"
export * from "./SpecialistForm.vue?vue&type=script&lang=js"
import style0 from "./SpecialistForm.vue?vue&type=style&index=0&id=0ac74bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac74bac",
  null
  
)

export default component.exports